import axios from 'axios';

import {
  ORG_VIEW,
  AGENCY_VIEW,
  APP_VIEW_ID_FIELD,
  ORG_VIEW_ID_FIELD
} from '../../common/support/viewConstants';
import { openLogoutModal } from '../actions/LogoutModalActions';

const { view } = window.App.context;
const sendOrgIdHeader =
  view && (view.current_view === ORG_VIEW || view.current_view === AGENCY_VIEW);

const defaultHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'X-Branch-Dashboard': 'dashboard',
  'x-csrf-token': window._csrfToken,
  'X-Client-Redirect': 'dashboard'
};

// We only want to set valid headers, otherwise the string 'null' will be sent
let headers = { ...defaultHeaders };
if (view) {
  if (sendOrgIdHeader) {
    headers = {
      ...defaultHeaders,
      'x-organization-id': view[ORG_VIEW_ID_FIELD]
    };
  } else {
    headers = { ...defaultHeaders, 'x-app-id': view[APP_VIEW_ID_FIELD] };
  }
}

const dash_api = axios.create({
  headers,
  withCredentials: true
});

export const dashApiInterceptorSetup = store => {
  // Adds a response interceptor when we initialize redux store
  dash_api.interceptors.response.use(
    resp => {
      if (resp.data && resp.data['X-Client-Redirect']) {
        store.dispatch(openLogoutModal());
      }
      return resp;
    },
    async error => {
      const { status } = error;
      if (status === 401) {
        await store.dispatch(openLogoutModal());
      }
      throw error;
    }
  );
};

export default dash_api;
